// extracted by css-extract-rspack-plugin
export default {"Timeline_Item":"TimelineRow-module__Timeline_Item__CWsyY","Octicon":"TimelineRow-module__Octicon__SMhVa"};